var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPetPark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2992_1008)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2992_1008",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 59,
    height: 59
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59 0H0V59H59V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2992_1008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8413 41.1777C10.2513 48.2823 15.6104 54.084 22.7396 54.084H34.515C42.5291 54.084 48.0358 47.6186 46.7083 39.7027C45.307 31.3936 37.2929 24.584 28.8608 24.584C19.7159 24.584 11.6034 32.0573 10.8413 41.1777Z",
    stroke: "#BC8639",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7387 18.4382C29.1329 18.4382 31.8845 15.6866 31.8845 12.2923C31.8845 8.89807 29.1329 6.14648 25.7387 6.14648C22.3444 6.14648 19.5928 8.89807 19.5928 12.2923C19.5928 15.6866 22.3444 18.4382 25.7387 18.4382Z",
    stroke: "#BC8639",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5292 21.3861C45.2447 21.3861 47.4459 19.1848 47.4459 16.4694C47.4459 13.754 45.2447 11.5527 42.5292 11.5527C39.814 11.5527 37.6125 13.754 37.6125 16.4694C37.6125 19.1848 39.814 21.3861 42.5292 21.3861Z",
    stroke: "#BC8639",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.625 31.2187C53.6615 31.2187 55.3125 29.5677 55.3125 27.5312C55.3125 25.4947 53.6615 23.8438 51.625 23.8438C49.5885 23.8438 47.9375 25.4947 47.9375 27.5312C47.9375 29.5677 49.5885 31.2187 51.625 31.2187Z",
    stroke: "#BC8639",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75944 26.302C12.4748 26.302 14.6761 24.1008 14.6761 21.3854C14.6761 18.67 12.4748 16.4688 9.75944 16.4688C7.04404 16.4688 4.84277 18.67 4.84277 21.3854C4.84277 24.1008 7.04404 26.302 9.75944 26.302Z",
    stroke: "#BC8639",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2992_1008"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 59,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPetPark);
export default __webpack_public_path__ + "static/media/pet-park.d359920a28f69f03feeab126bcf17eef.svg";
export { ForwardRef as ReactComponent };